import React from 'react';
import Help from './Help';
export default function InputField(_ref) {
  var classes = _ref.classes,
    style = _ref.style,
    label = _ref.label,
    parseLabel = _ref.parseLabel,
    help = _ref.help,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "input-field ".concat(classes || ''),
    style: style || {}
  }, label && /*#__PURE__*/React.createElement("div", {
    className: "flex-box items-center"
  }, parseLabel ? /*#__PURE__*/React.createElement("label", {
    dangerouslySetInnerHTML: {
      __html: label
    }
  }) : /*#__PURE__*/React.createElement("label", null, label), help && /*#__PURE__*/React.createElement(Help, {
    text: help
  })), children);
}